import { render, staticRenderFns } from "./RevisionSampleStep.vue?vue&type=template&id=9e2d4086&"
import script from "./RevisionSampleStep.vue?vue&type=script&lang=js&"
export * from "./RevisionSampleStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports